module.exports = __webpack_public_path__ + "static/media/Blue-With-Pattern.e69ffc42.png";